import React, { useState, useEffect } from 'react';
import api from '../services/api';
import useWindowWidth from '../hooks/useWindowWidth';
import { swalSuccess, swalError, swalConfirm } from '../utils/alert';
import './CardList.css';

function CategoryList({ onEdit }) {
  const [categories, setCategories] = useState([]);
  const width = useWindowWidth();

  const fetchCategories = () => {
    api.get('/categories')
      .then(response => setCategories(response.data))
      .catch(error => console.error('Houve um erro ao buscar as categorias!', error));
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleDelete = async (id) => {
    const result = await swalConfirm({ text: 'Tem certeza que deseja excluir esta categoria?' });
    if (!result.isConfirmed) return;
    try {
      await api.delete(`/categories/${id}`);
      swalSuccess('Categoria excluída com sucesso!');
      fetchCategories();
    } catch (error) {
      console.error('Houve um erro ao excluir a categoria!', error);
      swalError('Erro ao excluir categoria.');
    }
  };

  const getParentName = (parentId) => {
    if (!parentId) return null;
    const parent = categories.find(c => c.id === parentId);
    return parent ? parent.name : parentId;
  };

  const renderMobileView = () => (
    <div>
      {categories.map(category => (
        <div key={category.id} className="card-list-card" style={{ borderLeft: `4px solid ${category.color || '#6c757d'}` }}>
          <div className="card-list-card-header">
            <h3>{category.icon && <span className="me-2">{category.icon}</span>}{category.name}</h3>
            <span className={`badge bg-${category.type === 'receita' ? 'success' : category.type === 'despesa' ? 'danger' : 'info'}`}>
              {category.type}
            </span>
          </div>
          <div className="card-list-card-body">
            {getParentName(category.parent_id) && <p><strong>Categoria pai:</strong> {getParentName(category.parent_id)}</p>}
            <p><strong>Status:</strong> {category.status}</p>
          </div>
          <div className="card-list-card-footer">
            <button className="btn btn-warning btn-sm me-2" onClick={() => onEdit(category)}>Editar</button>
            <button className="btn btn-danger btn-sm" onClick={() => handleDelete(category.id)}>Excluir</button>
          </div>
        </div>
      ))}
    </div>
  );

  const renderDesktopView = () => (
    <table className="table table-striped table-hover">
      <thead className="thead-dark">
        <tr>
          <th>Nome</th>
          <th>Tipo</th>
          <th>Categoria Pai</th>
          <th>Cor</th>
          <th>Ícone</th>
          <th>Status</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        {categories.map(category => (
          <tr key={category.id}>
            <td>{category.name}</td>
            <td>{category.type}</td>
            <td>{getParentName(category.parent_id) || 'N/D'}</td>
            <td><span style={{ display: 'inline-block', width: 16, height: 16, borderRadius: '50%', backgroundColor: category.color || '#ccc' }}></span></td>
            <td>{category.icon || 'N/D'}</td>
            <td>{category.status}</td>
            <td>
              <button className="btn btn-warning btn-sm me-2" onClick={() => onEdit(category)}>Editar</button>
              <button className="btn btn-danger btn-sm" onClick={() => handleDelete(category.id)}>Excluir</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <div>
      <h2>Categorias</h2>
      {width < 768 ? renderMobileView() : renderDesktopView()}
    </div>
  );
}

export default CategoryList;
